export const InterfaceMock = () => {
  return (
    <svg
      width="123"
      height="126"
      viewBox="0 0 190 194"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.10522"
        y="0.524414"
        width="187.79"
        height="192.951"
        rx="5.47436"
        fill="#FFFDF9"
        stroke="#D7D3C9"
      />
      <rect
        x="18.5334"
        y="13.4219"
        width="51.4248"
        height="5.97436"
        rx="2.98718"
        fill="#D7D3C9"
      />
      <rect
        x="18.5334"
        y="34.8691"
        width="152.944"
        height="64.806"
        fill="#F5F3EB"
      />
      <rect
        x="18.5334"
        y="106.56"
        width="152.944"
        height="52.5743"
        fill="#F5F3EB"
      />
      <rect
        x="30.4922"
        y="45.6211"
        width="118.292"
        height="5.97436"
        rx="2.98718"
        fill="#ECE9DF"
      />
      <rect
        x="30.4792"
        y="123.288"
        width="129.046"
        height="5.97436"
        rx="2.98718"
        fill="#ECE9DF"
      />
      <rect
        x="30.4792"
        y="136.43"
        width="87.2256"
        height="5.97436"
        rx="2.98718"
        fill="#ECE9DF"
      />
      <rect
        x="69.6021"
        y="166.301"
        width="59.1458"
        height="18.0874"
        rx="2.76251"
        fill="#D7D3C9"
      />
      <path
        d="M37.3672 85.75H56.6172C58.136 85.75 59.3672 84.4815 59.3672 82.9167V63.0833C59.3672 61.5185 58.136 60.25 56.6172 60.25H37.3672C35.8484 60.25 34.6172 61.5185 34.6172 63.0833V82.9167C34.6172 84.4815 35.8484 85.75 37.3672 85.75ZM37.3672 85.75L52.4922 70.1667L59.3672 77.25M44.2422 68.0417C44.2422 69.2153 43.3188 70.1667 42.1797 70.1667C41.0406 70.1667 40.1172 69.2153 40.1172 68.0417C40.1172 66.8681 41.0406 65.9167 42.1797 65.9167C43.3188 65.9167 44.2422 66.8681 44.2422 68.0417Z"
        stroke="#D7D3C9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
